import { render, staticRenderFns } from "./DashboardOccupationSkills.vue?vue&type=template&id=350e84d8&scoped=true"
import script from "./DashboardOccupationSkills.vue?vue&type=script&lang=js"
export * from "./DashboardOccupationSkills.vue?vue&type=script&lang=js"
import style0 from "./DashboardOccupationSkills.vue?vue&type=style&index=0&id=350e84d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350e84d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('350e84d8')) {
      api.createRecord('350e84d8', component.options)
    } else {
      api.reload('350e84d8', component.options)
    }
    module.hot.accept("./DashboardOccupationSkills.vue?vue&type=template&id=350e84d8&scoped=true", function () {
      api.rerender('350e84d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/dashboards/DashboardOccupationSkills.vue"
export default component.exports